activ.directive('libraryListView', function() {
    return {
        replace: true,
        restrict: 'E',
        templateUrl: "./views/libraryListView.html?v=" + version,
        scope: true,
        link: function(scope, element, attrs) {

        }
    };
});